/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCompoundComptroller extends Contract<ITestCompoundComptroller> {
  claimComp: Send<(_holder: AddressLike) => void, ITestCompoundComptroller>
  'claimComp(address)': Send<(_holder: AddressLike) => void, ITestCompoundComptroller>
}

let ITestCompoundComptrollerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCompoundComptrollerBytecode = '0x';
}

// prettier-ignore
export const ITestCompoundComptroller = contract<ITestCompoundComptroller>(ITestCompoundComptrollerBytecode)`
  function claimComp(address _holder)
`;